import { FlexView } from '@facile-it/full-metal-ui/components'
import { NextPage } from 'next'
import Head from 'next/head'
import * as React from 'react'
import { Container, HeroContainer, HeroContent, HeroTitle } from '../components'
import { DownloadableDocumentList } from '../components/datavisualization/DownloadableDocumentList'
import * as styles from '../styles/Pages.css'

const create = (title: string, href: string): Record<'href' | 'title', string> => ({ href, title })

const SetInformativi: NextPage = () => (
    <>
        <Head>
            <title>Set informativi | Saturno assicurazioni</title>
        </Head>
        <HeroContainer hasBackground variant="small-one" paddingX={{ mobile: 'none', desktop: 'l' }}>
            <HeroContent>
                <HeroTitle marginBottom="none">Set Informativi</HeroTitle>
            </HeroContent>
        </HeroContainer>
        <Container
            marginTop="m"
            paddingTop="3xl"
            paddingBottom={{ mobile: 'hugexxl', desktop: '3xl' }}
            paddingX={{ mobile: 'none', desktop: 'l' }}
        >
            <FlexView.Container
                flexDirection={{ mobile: 'column', desktop: 'row' }}
                justifyContent={{ mobile: 'center', desktop: 'flexStart' }}
                alignItems={{ mobile: 'center', desktop: 'flexStart' }}
            >
                <FlexView.Item
                    width="content"
                    marginRight={{ mobile: 'none', desktop: 'l' }}
                    marginBottom={{ mobile: 'l', desktop: 'none' }}
                    className={styles.downloadBox}
                >
                    <DownloadableDocumentList
                        title="Prodotto Auto Saturno"
                        items={[create('Set informativo Auto Saturno', '/Polizza-Saturno-RCA.pdf')]}
                    />
                </FlexView.Item>
                <FlexView.Item width="content" className={styles.downloadBox}>
                    <DownloadableDocumentList
                        title="Prodotto Moto Saturno"
                        items={[create('Set informativo Moto Saturno', '/Polizza-Saturno-Moto.pdf')]}
                    />
                </FlexView.Item>
            </FlexView.Container>
        </Container>
    </>
)

export default SetInformativi
